import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { portfolioConfig } from 'components/Dashboards/Portfolio/portfolioConfig';
import { Manage } from 'components/pages/PhasePerformanceManagePage/components/Manage/Manage';

export const PhasePerformanceManagePage = () => {
    useFullStoryPageView({ pageName: portfolioConfig.phasePerformanceManage.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={portfolioConfig.phasePerformanceManage.title} showBack={true} />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <Manage />
            </MainContent>
        </PageContainer>
    );
};
